import { Controller } from "@hotwired/stimulus";
import { setModalLinkUrl } from "../../utils/modal_link";

export default class extends Controller {
  static targets = [
    "postcode",
    "addressLine1",
    "addressLine2",
    "addressLine3",
    "addressLine4",
    "conflictCheckLinkModal"
  ];
  static values = { valuationId: Number, propertyId: Number };

  connect() {
    this.valuationController = this.application.getControllerForElementAndIdentifier(
      document.querySelector('[data-controller~="valuation"]'),
      "valuation"
    );
    setModalLinkUrl(this.conflictCheckLinkModalTarget, this.conflictCheckUrlWithArguments("modal"));
    this.addApplicantFieldListeners();
  }

  disconnect() {
    this.removeApplicantFieldListeners();
  }

  addApplicantFieldListeners() {
    this.boundUpdateArguments = this.updateArguments.bind(this);
    this.valuationController?.applicantNameTarget?.addEventListener("change", this.boundUpdateArguments);
    this.valuationController?.applicantCompanyTarget?.addEventListener("change", this.boundUpdateArguments);
  }

  removeApplicantFieldListeners() {
    this.valuationController?.applicantNameTarget?.removeEventListener("change", this.boundUpdateArguments);
    this.valuationController?.applicantCompanyTarget?.removeEventListener("change", this.boundUpdateArguments);
  }

  updateArguments() {
    setModalLinkUrl(this.conflictCheckLinkModalTarget, this.conflictCheckUrlWithArguments("modal"));
  }

  conflictCheckUrlWithArguments(format) {
    const params = new URLSearchParams({
      postcode: this.postcode,
      address: this.address,
      applicant_name: this.applicantName,
      applicant_company: this.applicantCompany
    });
    const id = this.valuationIdValue;
    const propertyId = this.propertyIdValue;
    if (id && id > 0) params.append("id", id);
    if (propertyId && propertyId > 0) params.append("property_id", propertyId);
    return `${this.conflictCheckUrl}.${format}?${params.toString()}`;
  }

  get conflictCheckUrl() {
    return this.postcodeTarget.dataset.url;
  }

  get postcode() {
    return this.postcodeTarget.value;
  }

  get applicantName() {
    return this.valuationController?.applicantNameTarget?.value || "";
  }

  get applicantCompany() {
    return this.valuationController?.applicantCompanyTarget?.value || "";
  }

  get address() {
    return [
      this.addressLine1Target.value,
      this.addressLine2Target.value,
      this.addressLine3Target.value,
      this.addressLine4Target.value
    ].filter(x => x != null && x !== "").join(" ");
  }
}
